import { Component, Input } from '@angular/core';
import { Evento } from '../../models/evento.model';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'c-event-list',
    templateUrl: './event-list.component.html',
    styleUrl: './event-list.component.css',
    imports: [CommonModule]
})
export class EventListComponent {
  @Input() eventos: Evento[] = [];
}
